// extracted by mini-css-extract-plugin
module.exports = {"LoadingButton":"LoadingButton_LoadingButton__rlHly","isLoading":"LoadingButton_isLoading__3NM3X","LabelContent":"LoadingButton_LabelContent__YSMGN"};